/* eslint-disable react/prop-types */
import React from 'react'

import LiveSelect from 'live/components/forms/ui/select'

import { ChannelSelectorValue } from '../styles/editor'

const ChannelSelectorBase = ({
    curves,
    value: channel,
    onChange,
    sideview,
    disabled: notEditable,
    first,
    rowIndex
}) => {
    let options = Object.keys(curves)
        .map(mnemonic => ({
            label: curves?.[mnemonic]?.description || mnemonic,
            title: curves?.[mnemonic]?.description + ' (' + mnemonic + ')' || mnemonic,
            value: mnemonic
        }))
        .sort(({ value: valueA }, { value: valueB }) => (valueA === first ? -1 : valueB === first ? 1 : 0))

    // old rules with mnemonics that have been removed
    if (channel && !options.find(curve => curve.mnemonic === channel)) {
        options.push({ label: channel, title: channel, value: channel })
    }

    options = [
        ...(first ? [options[0]] : []),
        ...(sideview || rowIndex > 0 ? [{ label: 'Rig State', title: 'Rig State', value: 'rigstate' }] : []),
        ...options.slice(first ? 1 : 0)
    ]

    const disabled = (sideview && rowIndex === 0) || notEditable

    return (
        <LiveSelect
            noFormGroup
            options={options}
            value={channel || first}
            disabled={disabled}
            placeholder="Select channel..."
            className="Select-small"
            valueRenderer={option => <ChannelSelectorValue>{option.label}</ChannelSelectorValue>}
            onChange={option => {
                onChange(option, channel || first)
            }}
        />
    )
}

export default ChannelSelectorBase
